import { useMutation, useQueryClient } from "react-query";
import { toast } from 'react-toastify';
import { SrxApi } from '../api/SrxApi';

const useDeleteReleaseNote = () => {
  const queryClient = useQueryClient();

  const { mutate: deleteReleaseNote, isLoading } = useMutation(
    async ({ id }) => {
      const response = await SrxApi.delete(`/versions/release-notes/${id}`);
      return response?.data;
    },
    {
      onSuccess: (data) => {
        if (data) {
          toast.success(data?.message || "Release note deleted successfully!");
          queryClient.invalidateQueries(["getAllReleaseNote"]);
          queryClient.invalidateQueries(["currentVersion"]);
        }
      },
      onError: (error) => {
        const errorMessage = error?.response?.data?.message || error?.message || "Failed to delete release note";
        toast.error(errorMessage);
      },
    }
  );

  return { deleteReleaseNote, isDeleteReleaseNoteLoading: isLoading };
};

export default useDeleteReleaseNote;

